module.exports = __webpack_public_path__ + "static/media/icon_filter.abb608fc.svg";